import { get } from '../utils/api';

class UtilityAllowanceTypeService {
  getAll(options?: Object) {
    return get('/utilityAllowanceTypes', options);
  }
}

export default UtilityAllowanceTypeService;
